import { getActiveRelease, formatMoney } from './mm-2027-pricing.js';

const instances = new WeakMap();
function initialise(root) {
  if (instances.has(root)) return;
  const controller = new AbortController();
  const { signal } = controller;
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  const mobileTickets = matchMedia('(max-width: 999px)');
  const cleanups = [];
  root.querySelectorAll('[data-mmd-carousel]').forEach(carousel => {
    const track = carousel.querySelector('[data-mmd-track]');
    const slides = [...track.querySelectorAll('[data-mmd-slide]')];
    if (!slides.length) return;
    const isTickets = carousel.hasAttribute('data-mmd-ticket-carousel');
    const status = carousel.querySelector('[data-mmd-carousel-status]');
    let frame;
    const positions = () => slides.map(slide => Math.max(0, slide.offsetLeft - slides[0].offsetLeft));
    function index() {
      const offsets = positions();
      return offsets.reduce((best, offset, i) => Math.abs(offset - track.scrollLeft) < Math.abs(offsets[best] - track.scrollLeft) ? i : best, 0);
    }
    function sync() {
      const active = index();
      if (isTickets && mobileTickets.matches) track.style.height = `${Math.ceil(slides[active].getBoundingClientRect().height) + 16}px`;
      else track.style.removeProperty('height');
      carousel.dataset.activeSlide = String(active);
      if (status) status.textContent = `${isTickets ? 'Ticket' : carousel.dataset.mmdCarouselLabel || 'Review'} ${active + 1} of ${slides.length}`;
    }
    function move(direction) {
      if (isTickets && !mobileTickets.matches) return;
      const offsets = positions();
      const max = Math.max(0, track.scrollWidth - track.clientWidth);
      if (!max) return;
      const candidates = [...new Set(offsets.map(left => Math.min(left, max)))];
      let active = candidates.reduce((best, left, i) => Math.abs(left - track.scrollLeft) < Math.abs(candidates[best] - track.scrollLeft) ? i : best, 0);
      active = (active + direction + candidates.length) % candidates.length;
      track.scrollTo({ left: candidates[active], behavior: motion.matches ? 'instant' : 'smooth' });
    }
    carousel.querySelector('[data-mmd-prev]')?.addEventListener('click', () => move(-1), { signal });
    carousel.querySelector('[data-mmd-next]')?.addEventListener('click', () => move(1), { signal });
    track.addEventListener('keydown', event => {
      if (event.target !== track || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
      event.preventDefault(); move(event.key === 'ArrowRight' ? 1 : -1);
    }, { signal });
    track.addEventListener('scroll', () => { cancelAnimationFrame(frame); frame = requestAnimationFrame(sync); }, { signal, passive: true });
    const observer = new ResizeObserver(sync);
    slides.forEach(slide => observer.observe(slide));
    observer.observe(track);
    mobileTickets.addEventListener('change', () => { track.scrollLeft = 0; sync(); }, { signal });
    sync();
    cleanups.push(() => { observer.disconnect(); cancelAnimationFrame(frame); });
  });

  let timer;
  function updateTime() {
    if (root.hasAttribute('data-mmd-local-preview')) {
      try {
        const { current } = getActiveRelease(JSON.parse(root.dataset.mmConfig));
        root.querySelectorAll('[data-ticket-price]').forEach(node => {
          if (Object.hasOwn(current.prices, node.dataset.ticketPrice)) node.textContent = formatMoney(current.prices[node.dataset.ticketPrice]);
        });
      } catch { /* The server-rendered reference prices remain visible if a draft setting is invalid. */ }
    }
    timer = setTimeout(updateTime, 30000);
  }
  updateTime();
  document.addEventListener('visibilitychange', () => { if (!document.hidden) { clearTimeout(timer); updateTime(); } }, { signal });
  instances.set(root, () => { controller.abort(); clearTimeout(timer); cleanups.forEach(cleanup => cleanup()); instances.delete(root); });
}
function roots(context) { return [...(context.matches?.('[data-mmd-page]') ? [context] : []), ...context.querySelectorAll('[data-mmd-page]')]; }
roots(document).forEach(initialise);
document.addEventListener('shopify:section:load', event => roots(event.target).forEach(initialise));
document.addEventListener('shopify:section:unload', event => roots(event.target).forEach(root => instances.get(root)?.()));
